<template>
  <div>
    <v-tooltip v-if="viewButton" color="transparent" top>
      <template v-slot:activator="{ on }">
        <v-btn
          @click="openViewDialog"
          v-on="on"
          :disabled="loadingView"
          class="glow ml-2"
          color="secondary"
          x-small
          depressed
          fab>
          <template v-if="loadingView">
            <ProgressCircular color="secondary" />
          </template>
          <template v-else>
            <v-icon class="white--text" small>pageview</v-icon>
          </template>
        </v-btn>
      </template>
      <v-card class="elevation-2 px-4 py-2">
        <span>{{ $t('entities.users.viewEntity') }}</span>
      </v-card>
    </v-tooltip>
    <v-tooltip v-if="shopButton" color="transparent" top>
      <template v-slot:activator="{ on }">
        <v-btn
          @click="createPurchase"
          v-on="on"
          :disabled="!$store.getters.arena"
          class="glow ml-2"
          color="info"
          depressed
          fab
          x-small>
          <v-icon class="white--text" small>shop</v-icon>
        </v-btn>
      </template>
      <v-card class="elevation-2 px-4 py-2">
        <span>{{ $t('entities.users.shop') }}</span>
      </v-card>
    </v-tooltip>
    <v-tooltip v-if="awardButton" color="transparent" top>
      <template v-slot:activator="{ on }">
        <v-btn
          @click="openAwardDialog"
          v-on="on"
          :disabled="loadingAward"
          color="warning"
          class="glow ml-2"
          x-small
          depressed
          fab>
          <template v-if="loadingAward">
            <ProgressCircular color="warning" />
          </template>
          <template v-else>
            <v-icon class="white--text" small
              >mdi-trophy-variant-outline</v-icon
            >
          </template>
        </v-btn>
      </template>
      <v-card class="elevation-2 px-4 py-2">
        <span>{{ $t('entities.users.awardUser') }}</span>
      </v-card>
    </v-tooltip>
    <v-tooltip v-if="simulateSessionButton" color="transparent" top>
      <template v-slot:activator="{ on }">
        <v-btn
          @click="openSimulateSessionDialog"
          v-on="on"
          :disabled="!$store.getters.arena"
          color="warning"
          class="glow ml-2"
          x-small
          depressed
          fab>
          <template v-if="loadingSimulation">
            <ProgressCircular color="warning" />
          </template>
          <template v-else>
            <v-icon class="white--text" small>mdi-timer-sand</v-icon>
          </template>
        </v-btn>
      </template>
      <v-card class="elevation-2 px-4 py-2">
        <span>{{ $t('entities.users.simulateSession') }}</span>
      </v-card>
    </v-tooltip>
    <v-tooltip v-if="!userSession && sessionButton" color="transparent" top>
      <template v-slot:activator="{ on }">
        <v-btn
          @click="startPSSession"
          v-on="on"
          :disabled="
            !$store.getters.arena || loadingSessions || localEntity?.banned
          "
          color="success"
          class="glow ml-2"
          depressed
          x-small
          fab>
          <template v-if="loadingSessions">
            <ProgressCircular color="success" />
          </template>
          <template v-else>
            <v-icon class="white--text" small>mdi-controller</v-icon>
          </template>
        </v-btn>
      </template>
      <v-card class="elevation-2 px-4 py-2">
        <span>{{ $t('entities.sessions.ps-start') }}</span>
      </v-card>
    </v-tooltip>
    <v-tooltip v-if="!userSession && sessionButton" color="transparent" top>
      <template v-slot:activator="{ on }">
        <v-btn
          @click="startSimulatorSession"
          v-on="on"
          :disabled="
            !$store.getters.arena || loadingSessions || localEntity?.banned
          "
          color="success"
          class="glow ml-2"
          depressed
          x-small
          fab>
          <template v-if="loadingSessions">
            <ProgressCircular color="success" />
          </template>
          <template v-else>
            <v-icon class="white--text" small>mdi-steering</v-icon>
          </template>
        </v-btn>
      </template>
      <v-card class="elevation-2 px-4 py-2">
        <span>{{ $t('entities.sessions.sim-start') }}</span>
      </v-card>
    </v-tooltip>
    <v-tooltip v-if="userSession && sessionButton" color="transparent" top>
      <template v-slot:activator="{ on }">
        <v-btn
          @click="stopSession"
          v-on="on"
          :disabled="!$store.getters.arena || loadingSessions"
          color="error"
          class="glow ml-2"
          depressed
          x-small
          fab>
          <template v-if="loadingSessions">
            <ProgressCircular color="error" />
          </template>
          <template v-else>
            <v-icon class="white--text" small>power_settings_new</v-icon>
          </template>
        </v-btn>
      </template>
      <v-card class="elevation-2 px-4 py-2">
        <span>{{ $t('entities.sessions.stop') }}</span>
      </v-card>
    </v-tooltip>
    <EditButton
      v-if="canManage() && editButton"
      :text="$t('entities.users.editEntity')"
      :item="localEntity"
      :openEditDialog="openEditDialog" />
    <DeleteButton
      v-if="canManage() && deleteButton"
      :text="$t('entities.users.deleteEntity')"
      :item="localEntity"
      :openDeleteDialog="openDeleteDialog" />

    <v-dialog v-model="viewDialog" max-width="1000px">
      <v-card>
        <v-card-text class="px-0 pb-0">
          <v-toolbar class="elevation-2" color="primary">
            <v-toolbar-title class="ml-0">
              <span class="font-weight-bold white--text">{{
                $t('entities.users.viewEntity')
              }}</span>
            </v-toolbar-title>
            <v-spacer />
            <v-btn @click="viewDialog = false" icon dark>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container>
            <div class="text-center">
              <v-chip
                v-if="viewDialog && isStarterRank"
                color="error"
                class="font-weight-bold my-2"
                text-color="white"
                small>
                {{ $t('purchase.offerStarterPack') }}
              </v-chip>
            </div>
            <v-card class="my-4">
              <v-simple-table class="do-not-apply-hover" dense>
                <template v-if="viewDialog" v-slot:default>
                  <thead>
                    <tr>
                      <th colspan="3" class="text-left">
                        {{ $t('entities.orders.generalInformation') }}
                      </th>
                      <th class="text-right">#{{ editedEntity.id }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ $t('entities.users.attributes.username') }}</td>
                      <td class="font-weight-bold">
                        {{ editedEntity.username }}
                      </td>
                      <td>{{ $t('entities.roles.title') }}</td>
                      <td class="font-weight-bold">
                        <v-chip
                          v-for="(role, index) in editedEntity.roles"
                          :key="`role.${index}`"
                          color="primary"
                          class="font-weight-bold mr-2"
                          text-color="white"
                          small>
                          {{ role }}
                        </v-chip>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t('entities.users.attributes.banned') }}</td>
                      <td class="font-weight-bold">
                        <template v-if="editedEntity.banned">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-on="on" v-bind="attrs">
                                <BooleanComponent
                                  :boolean="editedEntity.banned" />
                                <span class="font-weight-bold">
                                  in {{ banArenaName }}</span
                                >
                              </span>
                            </template>
                            <span>{{ editedEntity.ban_reason }}</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <BooleanComponent :boolean="editedEntity.banned" />
                        </template>
                      </td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>{{ $t('generalAttributes.coins') }}</td>
                      <td class="font-weight-bold">
                        {{ addThousandSeparator(editedEntity.wallet.balance) }}
                        <CoinIcon />
                      </td>
                      <td>{{ $t('entities.ranks.attributes.experience') }}</td>
                      <td class="font-weight-bold">
                        {{
                          addThousandSeparator(editedEntity.experience.balance)
                        }}
                        <ExperienceImage class="pt-1" />
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t('entities.users.attributes.rank') }}</td>
                      <td class="font-weight-bold">
                        <v-chip
                          color="primary"
                          class="font-weight-bold mr-2"
                          text-color="white"
                          small>
                          {{ editedEntity.experience.rank.name }}
                        </v-chip>
                      </td>
                      <td>
                        {{ $t('entities.users.attributes.registeredAt') }}
                      </td>
                      <td class="font-weight-bold">
                        {{
                          fromUtcDateTimeToCurrent(
                            editedEntity.created_at,
                            true,
                            true,
                          )
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t('entities.users.attributes.cardId') }}</td>
                      <td class="font-weight-bold">
                        {{ editedEntity.card_id || '/' }}
                      </td>
                      <td>{{ $t('entities.users.attributes.avatar') }}</td>
                      <td class="font-weight-bold">
                        <template v-if="editedEntity.avatar">
                          <img
                            :src="editedEntity.avatar"
                            alt="Avatar"
                            width="20px" />
                        </template>
                        <template v-else> / </template>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t('entities.sessions.bonuses.legend') }}</td>
                      <td class="font-weight-bold">
                        {{ editedEntity.bonuses.legend_bonus * 100 }}%
                      </td>
                      <td>{{ $t('entities.sessions.bonuses.rank') }}</td>
                      <td class="font-weight-bold">
                        {{ editedEntity.bonuses.rank_bonus * 100 }}%
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t('entities.sessions.bonuses.reward') }}</td>
                      <td class="font-weight-bold">
                        {{ editedEntity.bonuses.reward_bonus * 100 }}%
                      </td>
                      <td>
                        {{ $t('entities.sessions.bonuses.subscription') }}
                      </td>
                      <td class="font-weight-bold">
                        {{ editedEntity.bonuses.subscription_bonus * 100 }}%
                      </td>
                    </tr>
                    <tr v-if="editedEntity.reset_password">
                      <td colspan="2">
                        {{ $t('entities.users.passwordResetExpiresAt') }}
                      </td>
                      <td colspan="2" class="font-weight-bold">
                        {{
                          fromUtcDateTimeToCurrent(
                            editedEntity.reset_password.expires_at,
                            true,
                            true,
                          )
                        }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-row align="center" class="my-2">
                <template v-if="canManage(user)">
                  <v-col cols="12" class="text-center">
                    <v-btn
                      @click="resetPassword(editedEntity.id)"
                      :disabled="resettingPassword"
                      :loading="resettingPassword"
                      color="primary"
                      small>
                      <span>{{
                        resettingPassword
                          ? $t('entities.users.resettingPassword')
                          : $t(`entities.users.resetPassword`)
                      }}</span>
                    </v-btn>
                  </v-col>
                </template>
              </v-row>
              <v-simple-table class="do-not-apply-hover" dense>
                <template v-if="viewDialog" v-slot:default>
                  <thead>
                    <tr>
                      <th colspan="4" class="text-left">
                        {{ $t('entities.users.identity') }}
                        <Status
                          v-if="editedEntity.identity.id"
                          :status="editedEntity.identity.status" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="editedEntity.identity.id">
                      <tr>
                        <td>{{ $t('generalAttributes.fullName') }}</td>
                        <td class="font-weight-bold">
                          {{ editedEntity.identity.name || '/' }}
                        </td>
                        <td>{{ $t('generalAttributes.address') }}</td>
                        <td class="font-weight-bold">
                          {{ editedEntity.identity.address || '/' }}
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t('entities.users.attributes.birthdate') }}</td>
                        <td class="font-weight-bold">
                          {{ editedEntity.identity.birthdate || '/' }}
                        </td>
                        <td>{{ $t('miscellaneous.createdAt') }}</td>
                        <td class="font-weight-bold">
                          {{
                            fromUtcDateTimeToCurrent(
                              editedEntity.identity.created_at,
                              true,
                              true,
                            )
                          }}
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="4">
                          <i>{{ $t('entities.users.noIdentitySet') }}</i>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
              <v-row
                v-if="
                  editedEntity.identity.id &&
                  editedEntity.identity.status === 'PENDING'
                "
                align="center"
                class="my-2">
                <v-col cols="12" class="text-center">
                  <v-btn
                    @click="approveIdentity(editedEntity.id)"
                    :disabled="approvingIdentity || rejectingIdentity"
                    :loading="approvingIdentity"
                    color="success"
                    class="mx-2"
                    small>
                    <span>{{
                      approvingIdentity
                        ? $t('entities.users.approvingIdentity')
                        : $t(`entities.users.approveIdentity`)
                    }}</span>
                  </v-btn>
                  <v-btn
                    @click="rejectIdentity(editedEntity.id)"
                    :disabled="approvingIdentity || rejectingIdentity"
                    :loading="rejectingIdentity"
                    color="error"
                    class="mx-2"
                    small>
                    <span>{{
                      rejectingIdentity
                        ? $t('entities.users.rejectingIdentity')
                        : $t(`entities.users.rejectIdentity`)
                    }}</span>
                  </v-btn>
                </v-col>
              </v-row>
              <v-simple-table class="do-not-apply-hover" dense>
                <template v-if="viewDialog" v-slot:default>
                  <thead>
                    <tr>
                      <th colspan="4" class="text-left">
                        {{ $t('entities.users.attributes.email') }}
                        <Status
                          v-if="editedEntity.email.id"
                          :status="editedEntity.email.status" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <template v-if="editedEntity.email.id">
                        <td>{{ $t('generalAttributes.address') }}</td>
                        <td class="font-weight-bold">
                          <CopyTooltip :text="editedEntity.email.address" />
                        </td>
                        <td>{{ $t('miscellaneous.createdAt') }}</td>
                        <td class="font-weight-bold">
                          {{
                            fromUtcDateTimeToCurrent(
                              editedEntity.email.created_at,
                              true,
                              true,
                            )
                          }}
                        </td>
                      </template>
                      <template v-else>
                        <td colspan="4">
                          <i>{{ $t('entities.users.noEmailSet') }}</i>
                        </td>
                      </template>
                    </tr>
                  </tbody>
                  <thead>
                    <tr>
                      <th colspan="4" class="text-left">
                        {{ $t('entities.users.attributes.phone') }}
                        <Status
                          v-if="editedEntity.phone.id"
                          :status="editedEntity.phone.status" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <template v-if="editedEntity.phone.id">
                        <td>{{ $t('entities.orders.attributes.number') }}</td>
                        <td class="font-weight-bold">
                          <CopyTooltip
                            :text="`+${editedEntity.phone.number}`" />
                        </td>
                        <td>{{ $t('miscellaneous.createdAt') }}</td>
                        <td class="font-weight-bold">
                          {{
                            fromUtcDateTimeToCurrent(
                              editedEntity.phone.created_at,
                              true,
                              true,
                            )
                          }}
                        </td>
                      </template>
                      <template v-else>
                        <td colspan="4">
                          <i>{{ $t('entities.users.noPhoneSet') }}</i>
                        </td>
                      </template>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
            <v-card class="my-4">
              <v-card-text>
                <v-row>
                  <!-- Most Purchased Items Table -->
                  <v-col cols="12" md="6">
                    <h3 class="text-subtitle-1 grey--text text--darken-1 mb-2">
                      {{ $t('purchase.usersTopPurchases') }}
                    </h3>
                    <v-simple-table dense class="elevation-1 mb-4">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              {{ $t('generalAttributes.name') }}
                            </th>
                            <th class="text-right">
                              {{ $t('generalAttributes.quantity') }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="loadingUserMostPurchased">
                            <td colspan="2" class="text-center">
                              <v-progress-linear
                                indeterminate
                                color="primary"></v-progress-linear>
                            </td>
                          </tr>
                          <tr v-else-if="userMostPurchased.length === 0">
                            <td
                              colspan="2"
                              class="text-center grey--text text--darken-1">
                              {{ $t('purchase.noPurchases') }}
                            </td>
                          </tr>
                          <tr
                            v-for="item in userMostPurchased"
                            :key="item.item_name">
                            <td>{{ item.item_name }}</td>
                            <td class="text-right font-weight-bold">
                              {{ addThousandSeparator(item.total_sold) }}x
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>

                  <!-- Most Played Games Table -->
                  <v-col cols="12" md="6">
                    <h3 class="text-subtitle-1 grey--text text--darken-1 mb-2">
                      {{ $t('purchase.usersTopGames') }}
                    </h3>
                    <v-simple-table dense class="elevation-1 mb-4">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              {{ $t('generalAttributes.name') }}
                            </th>
                            <th class="text-right">
                              {{ $t('purchase.playtime') }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="loadingUserMostPlayedGames">
                            <td colspan="2" class="text-center">
                              <v-progress-linear
                                indeterminate
                                color="primary"></v-progress-linear>
                            </td>
                          </tr>
                          <tr v-else-if="userMostGames.length === 0">
                            <td
                              colspan="2"
                              class="text-center grey--text text--darken-1">
                              {{ $t('purchase.noGamesPlayed') }}
                            </td>
                          </tr>
                          <tr v-for="item in userMostGames" :key="item.game_id">
                            <td>{{ item.name }}</td>
                            <td class="text-right font-weight-bold">
                              {{
                                addThousandSeparator(
                                  item.total_playtime_h.toFixed(2),
                                )
                              }}
                              h
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-row v-if="isAdmin" align="center" class="my-2">
              <v-col cols="12" class="text-center">
                <v-btn @click="goToCoinHistory" color="primary" small>
                  <span>{{ $t('navigationDrawer.users.coinHistory') }}</span>
                </v-btn>
              </v-col>
            </v-row>
            <v-card class="my-4">
              <template v-if="viewDialog">
                <v-data-table
                  :headers="inventoryHeaders"
                  :items="editedEntity.inventory"
                  :items-per-page="5"
                  :header-props="{
                    sortIcon: 'arrow_circle_up',
                    sortByText: $t('miscellaneous.sortBy'),
                  }"
                  :no-data-text="
                    $t('components.dataTableHeader.noDataAvailable')
                  "
                  :footer-props="{
                    itemsPerPageText: $t('components.rowsPerPage.rows'),
                    itemsPerPageAllText: $t('components.rowsPerPage.all'),
                  }"
                  class="do-not-apply-hover px-2"
                  dense>
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-toolbar-title>
                        {{ $t('entities.users.inventory') }}
                      </v-toolbar-title>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <small>{{ editedEntity.inventory.length }}</small>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </template>
                  <template v-slot:item.name="{ item }">
                    <span class="text-capitalize">{{ item.name }}</span>
                    <template v-if="item.type === 'bonus'">
                      ({{ item.amount * 100 }}%)
                      <v-chip
                        class="font-weight-bold"
                        :color="item.active ? 'success' : 'error'"
                        text-color="white"
                        small>
                        {{
                          $t(
                            `entities.games.${
                              item.active ? 'attributes.active' : 'notActive'
                            }`,
                          )
                        }}
                      </v-chip>
                      <template v-if="item.duration">
                        <PrimaryChip
                          :text="`${$t(
                            'entities.inventoryItems.duration',
                          )}: ${fromSecondsToHumanReadableFormat(
                            item.duration,
                          )}`" />
                        <v-chip
                          v-if="item.updated_at"
                          class="font-weight-bold ml-2"
                          color="secondary"
                          text-color="white"
                          small>
                          {{ $t('entities.carts.attributes.expiresAt') }}:
                          {{
                            formatDate(
                              new Date(
                                new Date(item.updated_at).getTime() +
                                  item.duration * 1000,
                              ),
                              true,
                              true,
                            )
                          }}
                        </v-chip>
                      </template>
                    </template>
                    <template v-else-if="item.type === 'coin'">
                      ({{ item.amount }} <CoinIcon />)
                    </template>
                  </template>
                  <template v-slot:item.created_at="{ item }">
                    {{ formatDate(new Date(item.created_at), true, true) }}
                  </template>
                  <template v-slot:footer.page-text="items">
                    {{ items.pageStart }} - {{ items.pageStop }}
                    {{ $t('components.pagination.of') }} {{ items.itemsLength }}
                  </template>
                </v-data-table>
              </template>
            </v-card>
            <v-card class="my-4">
              <template v-if="viewDialog">
                <v-data-table
                  :headers="achievementsHeaders"
                  :items="editedEntity.achievements"
                  item-key="name"
                  :items-per-page="5"
                  :header-props="{
                    sortIcon: 'arrow_circle_up',
                    sortByText: $t('miscellaneous.sortBy'),
                  }"
                  :no-data-text="
                    $t('components.dataTableHeader.noDataAvailable')
                  "
                  :footer-props="{
                    itemsPerPageText: $t('components.rowsPerPage.rows'),
                    itemsPerPageAllText: $t('components.rowsPerPage.all'),
                  }"
                  class="do-not-apply-hover px-2"
                  dense>
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-toolbar-title>{{
                        $t('entities.achievements.title')
                      }}</v-toolbar-title>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <small>{{ editedEntity.achievements.length }}</small>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </template>
                  <template v-slot:item.points="{ item }">
                    <PrimaryChip :text="item.points.toString()" margin="ml-0" />
                  </template>
                  <template v-slot:item.created_at="{ item }">
                    <span v-if="item.created_at">
                      {{
                        fromUtcDateTimeToCurrent(item.created_at, true, true)
                      }}
                    </span>
                    <span v-else> / </span>
                  </template>
                  <template v-slot:item.progress_value="{ item }">
                    <span
                      >{{ Math.round(item.progress_value * 100) / 100 }}%</span
                    >
                  </template>
                  <template v-slot:item.progress_updated_at="{ item }">
                    <span v-if="item.progress_updated_at">
                      {{
                        fromUtcDateTimeToCurrent(
                          item.progress_updated_at,
                          true,
                          true,
                        )
                      }}
                    </span>
                    <span v-else> / </span>
                  </template>
                  <template v-slot:footer.page-text="items">
                    {{ items.pageStart }} - {{ items.pageStop }}
                    {{ $t('components.pagination.of') }} {{ items.itemsLength }}
                  </template>
                </v-data-table>
              </template>
            </v-card>
            <v-card class="my-4">
              <template v-if="viewDialog">
                <v-data-table
                  :headers="questsHeaders"
                  :items="editedEntity.quests"
                  item-key="name"
                  :items-per-page="5"
                  :header-props="{
                    sortIcon: 'arrow_circle_up',
                    sortByText: $t('miscellaneous.sortBy'),
                  }"
                  :no-data-text="
                    $t('components.dataTableHeader.noDataAvailable')
                  "
                  :footer-props="{
                    itemsPerPageText: $t('components.rowsPerPage.rows'),
                    itemsPerPageAllText: $t('components.rowsPerPage.all'),
                  }"
                  class="do-not-apply-hover px-2"
                  dense>
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-toolbar-title>{{
                        $t('entities.quests.title')
                      }}</v-toolbar-title>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <small>{{ editedEntity.quests.length }}</small>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </template>
                  <template v-slot:item.pool_type="{ item }">
                    <v-chip
                      color="primary"
                      class="font-weight-bold mr-2"
                      text-color="white"
                      small>
                      {{
                        $t(`entities.quests.${item.pool_type.toLowerCase()}`)
                      }}
                    </v-chip>
                  </template>
                  <template v-slot:item.created_at="{ item }">
                    <span v-if="item.created_at">
                      {{
                        fromUtcDateTimeToCurrent(item.created_at, true, true)
                      }}
                    </span>
                    <span v-else> / </span>
                  </template>
                  <template v-slot:item.progress_value="{ item }">
                    <span
                      >{{ Math.round(item.progress_value * 100) / 100 }}%</span
                    >
                  </template>
                  <template v-slot:item.progress_updated_at="{ item }">
                    <span v-if="item.progress_updated_at">
                      {{
                        fromUtcDateTimeToCurrent(
                          item.progress_updated_at,
                          true,
                          true,
                        )
                      }}
                    </span>
                    <span v-else> / </span>
                  </template>
                  <template v-slot:footer.page-text="items">
                    {{ items.pageStart }} - {{ items.pageStop }}
                    {{ $t('components.pagination.of') }} {{ items.itemsLength }}
                  </template>
                </v-data-table>
              </template>
            </v-card>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn @click="viewDialog = false" color="dark darken-1" text>
            {{ $t('miscellaneous.ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="awardDialog" max-width="600px">
      <v-card>
        <v-card-text class="px-0 pb-0">
          <v-toolbar class="elevation-2" color="primary">
            <v-toolbar-title class="ml-0">
              <span class="font-weight-bold white--text"
                >{{ $t('entities.users.awardUser') }}
                {{ editedEntity.username }}</span
              >
            </v-toolbar-title>
            <v-spacer />
            <v-btn @click="awardDialog = false" icon dark>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container>
            <v-card class="px-4 pt-4">
              <v-row align="center">
                <RequiredFields />
                <v-col cols="12">
                  <v-form
                    v-if="awardDialog"
                    @submit.prevent="awardEvent"
                    method="POST"
                    ref="awardForm">
                    <v-col cols="12" class="pt-4 pb-0">
                      <v-select
                        v-model="editedEntity.event"
                        :items="filteredEvents"
                        :rules="[(v) => !!v || $t('validation.required')]"
                        :menu-props="{ bottom: true, offsetY: true }"
                        :no-data-text="
                          $t('components.dataTableHeader.noDataAvailable')
                        "
                        :disabled="awardingEvent"
                        item-text="name"
                        class="do-not-apply-transform"
                        prepend-inner-icon="mdi-trophy-award"
                        return-object
                        solo>
                        <template v-slot:label>
                          {{ $t('entities.events.title') }}
                          <span :style="{ color: 'red' }">*</span>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="12" class="text-center pt-0">
                      <v-btn
                        @click="awardEvent"
                        :disabled="awardingEvent"
                        :loading="awardingEvent"
                        color="primary">
                        <span>{{
                          awardingEvent
                            ? $t('entities.users.awarding')
                            : $t(`entities.users.awardProgress`)
                        }}</span>
                      </v-btn>
                    </v-col>
                  </v-form>
                </v-col>
              </v-row>
            </v-card>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn @click="awardDialog = false" color="dark darken-1" text>
            {{ $t('miscellaneous.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SimulateSessionDialog v-model="showSimulateDialog" :entity="localEntity" />
    <v-dialog v-model="editDialog" max-width="1000px">
      <v-card>
        <v-card-text class="px-0 pb-0">
          <EditToolbar
            :formTitle="$t('entities.users.editEntity')"
            :closeEditDialog="closeEditDialog" />
          <v-container>
            <v-card class="mt-4 px-4 pb-4">
              <v-form @submit.prevent="save" method="POST" ref="form">
                <v-row align="center">
                  <RequiredFields />
                  <v-col cols="12" sm="6" class="position-relative">
                    <v-text-field
                      :value="editedEntity.username"
                      @change="(v) => (editedEntity.username = v)"
                      :rules="[]"
                      :label="$t('entities.users.attributes.username')"
                      :disabled="true"
                      prepend-icon="mdi-account-box"></v-text-field>
                  </v-col>
                  <v-col
                    v-if="!isTargetAdmin"
                    cols="12"
                    sm="6"
                    class="position-relative">
                    <v-text-field
                      v-model="editedEntity.password"
                      @click:append="show = !show"
                      :rules="[minimumPasswordOrEmpty]"
                      :type="show ? 'text' : 'password'"
                      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                      :prepend-icon="show ? 'lock_open' : 'lock'"
                      :label="$t('login.password')"
                      counter
                      loading>
                      <template v-slot:progress>
                        <v-progress-linear
                          :value="progress"
                          :color="color"
                          height="5"
                          absolute
                          striped></v-progress-linear>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col v-if="!isTargetAdmin" cols="12" sm="6" class="pb-0">
                    <v-select
                      :value="editedEntity.roles"
                      @change="editedEntity.roles = $event"
                      :items="availableRoles"
                      :menu-props="{ bottom: true, offsetY: true }"
                      :label="$t(`entities.roles.title`)"
                      item-text="name"
                      item-value="id"
                      class="do-not-apply-transform"
                      prepend-inner-icon="mdi-account-circle"
                      return-object
                      multiple
                      solo>
                      <template v-slot:selection="data">
                        <span v-if="data.index === 0"
                          >{{ $t(`entities.roles.title`) }}:</span
                        >
                        <v-chip color="primary" small>
                          {{ data.item }}
                        </v-chip>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col v-if="!isTargetAdmin" cols="12" sm="3" class="pb-0">
                    <v-switch
                      :input-value="editedEntity.banned"
                      @change="(v) => (editedEntity.banned = v)"
                      :label="$t('entities.users.attributes.banned')"
                      prepend-icon="done"
                      inset></v-switch>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    v-if="editedEntity.banned && !isTargetAdmin">
                    <v-text-field
                      v-model="editedEntity.ban_reason"
                      :rules="[requiredIfBanned]"
                      :label="$t('entities.users.attributes.banReason')"
                      prepend-icon="mdi-comment-alert"></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    v-if="editedEntity.banned && !isTargetAdmin">
                    <v-select
                      v-model="editedEntity.ban_arena_id"
                      :items="localArenas"
                      item-text="name"
                      item-value="id"
                      :rules="[requiredIfBanned]"
                      :label="$t('entities.users.attributes.banArena')"
                      prepend-icon="mdi-map-marker"
                      :disabled="!isAdmin"
                      :readonly="!isAdmin"></v-select>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-text-field
                      :value="editedEntity.card_id"
                      @change="(v) => (editedEntity.card_id = v)"
                      :label="$t('entities.users.attributes.cardId')"
                      :rules="[numeric, min]"
                      prepend-icon="mdi-card-account-details"
                      type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <h3 class="mt-4 grey--text text--darken-1">
                      {{ $t('entities.users.identity') }}
                    </h3>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      :value="editedEntity.identity.name"
                      @change="(v) => (editedEntity.identity.name = v)"
                      :label="$t('generalAttributes.fullName')"
                      prepend-icon="person"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" class="position-relative">
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      ref="menu"
                      transition="scale-transition"
                      min-width="auto"
                      offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="editedEntity.identity.birthdate"
                          v-bind="attrs"
                          v-on="on"
                          :label="$t('entities.users.attributes.birthdate')"
                          prepend-icon="mdi-calendar"
                          clearable
                          readonly></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="editedEntity.identity.birthdate"
                        @change="saveDate"
                        :active-picker.sync="activePicker"
                        :max="
                          new Date(
                            Date.now() - new Date().getTimezoneOffset() * 60000,
                          )
                            .toISOString()
                            .substr(0, 10)
                        "
                        min="1921-01-01"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      :value="editedEntity.identity.address"
                      @change="(v) => (editedEntity.identity.address = v)"
                      :label="$t('generalAttributes.address')"
                      prepend-icon="house"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      :value="editedEntity.identity.pidn"
                      @change="(v) => (editedEntity.identity.pidn = v)"
                      :label="$t('generalAttributes.pidn')"
                      prepend-icon="short_text"></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <h3 class="mt-4 grey--text text--darken-1">
                      {{ $t('entities.users.contact') }}
                    </h3>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      :value="editedEntity.email.address"
                      @change="(v) => (editedEntity.email.address = v)"
                      :label="$t('entities.users.attributes.email')"
                      :rules="[email]"
                      prepend-icon="email"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-row align="center">
                      <v-col cols="6" sm="5" md="4">
                        <v-autocomplete
                          v-model="editedEntity.phone.country_code"
                          :items="countries"
                          :menu-props="{ bottom: true, offsetY: true }"
                          class="do-not-apply-transform mt-2"
                          prepend-inner-icon="phone"
                          item-text="name"
                          item-value="dialCode"
                          solo>
                          <template v-slot:selection="data">
                            <img
                              :src="`https://flagcdn.com/w20/${data.item.iso2}.png`"
                              width="15px"
                              height="15px"
                              class="mr-2" />
                            +{{ data.item.dialCode }}
                          </template>
                          <template v-slot:item="data">
                            <img
                              :src="`https://flagcdn.com/w20/${data.item.iso2}.png`"
                              width="15px"
                              height="15px"
                              class="mr-2" />
                            {{ data.item.name }} +{{ data.item.dialCode }}
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="6" sm="7" md="8" class="pl-0">
                        <v-text-field
                          :value="editedEntity.phone.national_number"
                          @change="
                            (v) => (editedEntity.phone.national_number = v)
                          "
                          :rules="[phoneNumber, requiredIfCountryCode]"
                          :label="$t('generalAttributes.phone')"
                          :disabled="
                            !editedEntity.phone.country_code
                          "></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <ValidationErrors
                  v-if="validationErrors.length"
                  :errors="validationErrors"
                  class="mt-6" />
              </v-form>
            </v-card>
          </v-container>
        </v-card-text>
        <EditCardActions
          :save="save"
          :saving="saving"
          :closeEditDialog="closeEditDialog" />
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" max-width="1000px">
      <v-card>
        <v-card-text class="px-0 pb-0">
          <DeleteToolbar
            :text="$t('entities.users.deleteEntity')"
            :closeDeleteDialog="closeDeleteDialog" />
          <v-container>
            <v-card>
              <v-simple-table class="do-not-apply-hover" dense>
                <template v-if="deleteDialog" v-slot:default>
                  <thead>
                    <tr>
                      <th colspan="4" class="text-left">
                        {{ $t('entities.orders.generalInformation') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ $t('entities.users.attributes.username') }}</td>
                      <td class="font-weight-bold">
                        {{ toDeleteEntity.username }}
                      </td>
                      <td>{{ $t('entities.roles.title') }}</td>
                      <td class="font-weight-bold">
                        <v-chip
                          v-for="(role, index) in toDeleteEntity.roles"
                          color="primary"
                          :key="`role-${index}`"
                          class="font-weight-bold mr-2"
                          text-color="white"
                          small>
                          {{ role }}
                        </v-chip>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t('entities.users.attributes.banned') }}</td>
                      <td class="font-weight-bold">
                        <template v-if="toDeleteEntity.banned">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-on="on" v-bind="attrs">
                                <BooleanComponent
                                  :boolean="toDeleteEntity.banned" />
                              </span>
                              <span
                                v-if="toDeleteEntity.banned"
                                class="font-weight-bold">
                                in {{ banArenaName }}</span
                              >
                            </template>
                            <span>{{ toDeleteEntity.ban_reason }}</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <BooleanComponent :boolean="toDeleteEntity.banned" />
                        </template>
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>{{ $t('generalAttributes.coins') }}</td>
                      <td class="font-weight-bold">
                        {{
                          addThousandSeparator(toDeleteEntity.wallet.balance)
                        }}
                        <CoinIcon />
                      </td>
                      <td>{{ $t('entities.ranks.attributes.experience') }}</td>
                      <td class="font-weight-bold">
                        {{
                          addThousandSeparator(
                            toDeleteEntity.experience.balance,
                          )
                        }}
                        <ExperienceImage class="pt-1" />
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t('entities.users.attributes.rank') }}</td>
                      <td class="font-weight-bold">
                        <v-chip
                          color="primary"
                          class="font-weight-bold mr-2"
                          text-color="white"
                          small>
                          {{ toDeleteEntity.experience.rank.name }}
                        </v-chip>
                      </td>
                      <td>
                        {{ $t('entities.users.attributes.registeredAt') }}
                      </td>
                      <td class="font-weight-bold">
                        {{
                          fromUtcDateTimeToCurrent(
                            toDeleteEntity.created_at,
                            true,
                            true,
                          )
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t('entities.users.attributes.cardId') }}</td>
                      <td class="font-weight-bold">
                        {{ toDeleteEntity.card_id || '/' }}
                      </td>
                      <td>{{ $t('entities.users.attributes.avatar') }}</td>
                      <td class="font-weight-bold">
                        <template v-if="toDeleteEntity.avatar">
                          <img
                            :src="toDeleteEntity.avatar"
                            alt="Avatar"
                            width="20px" />
                        </template>
                        <template v-else> / </template>
                      </td>
                    </tr>
                  </tbody>
                  <thead>
                    <tr>
                      <th colspan="4" class="text-left">
                        {{ $t('entities.users.identity') }}
                        <Status
                          v-if="toDeleteEntity.identity.id"
                          :status="toDeleteEntity.identity.status" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="toDeleteEntity.identity.id">
                      <tr>
                        <td>{{ $t('generalAttributes.fullName') }}</td>
                        <td class="font-weight-bold">
                          {{ toDeleteEntity.identity.name || '/' }}
                        </td>
                        <td>{{ $t('generalAttributes.address') }}</td>
                        <td class="font-weight-bold">
                          {{ toDeleteEntity.identity.address || '/' }}
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t('entities.users.attributes.birthdate') }}</td>
                        <td class="font-weight-bold">
                          {{ toDeleteEntity.identity.birthdate || '/' }}
                        </td>
                        <td>{{ $t('miscellaneous.createdAt') }}</td>
                        <td class="font-weight-bold">
                          {{
                            fromUtcDateTimeToCurrent(
                              toDeleteEntity.identity.created_at,
                              true,
                              true,
                            )
                          }}
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="4">
                          <i>{{ $t('entities.users.noIdentitySet') }}</i>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                  <thead>
                    <tr>
                      <th colspan="4" class="text-left">
                        {{ $t('entities.users.attributes.email') }}
                        <Status
                          v-if="toDeleteEntity.email.id"
                          :status="toDeleteEntity.email.status" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <template v-if="toDeleteEntity.email.address.length">
                        <td>{{ $t('generalAttributes.address') }}</td>
                        <td class="font-weight-bold">
                          <CopyTooltip :text="toDeleteEntity.email.address" />
                        </td>
                        <td>{{ $t('miscellaneous.createdAt') }}</td>
                        <td class="font-weight-bold">
                          {{
                            fromUtcDateTimeToCurrent(
                              toDeleteEntity.email.created_at,
                              true,
                              true,
                            )
                          }}
                        </td>
                      </template>
                      <template v-else>
                        <td colspan="4">
                          <i>{{ $t('entities.users.noEmailSet') }}</i>
                        </td>
                      </template>
                    </tr>
                  </tbody>
                  <thead>
                    <tr>
                      <th colspan="4" class="text-left">
                        {{ $t('entities.users.attributes.phone') }}
                        <Status
                          v-if="toDeleteEntity.phone.id"
                          :status="toDeleteEntity.phone.status" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <template v-if="toDeleteEntity.phone.id">
                        <td>{{ $t('entities.orders.attributes.number') }}</td>
                        <td class="font-weight-bold">
                          <CopyTooltip
                            :text="`+${toDeleteEntity.phone.number}`" />
                        </td>
                        <td>{{ $t('miscellaneous.createdAt') }}</td>
                        <td class="font-weight-bold">
                          {{
                            fromUtcDateTimeToCurrent(
                              toDeleteEntity.phone.created_at,
                              true,
                              true,
                            )
                          }}
                        </td>
                      </template>
                      <template v-else>
                        <td colspan="4">
                          <i>{{ $t('entities.users.noPhoneSet') }}</i>
                        </td>
                      </template>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-container>
        </v-card-text>
        <DeleteCardActions
          :deleteEntity="deleteEntity"
          :deleting="deleting"
          :closeDeleteDialog="closeDeleteDialog" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import ProgressCircular from '@/components/ProgressCircular.vue'
import CopyTooltip from '@/components/CopyTooltip.vue'
import Status from '@/components/Status.vue'
import CoinIcon from '@/components/CoinIcon.vue'
import BooleanComponent from '@/components/Boolean.vue'
import ExperienceImage from '@/components/ExperienceImage.vue'
import PrimaryChip from '@/components/PrimaryChip.vue'
import User from '@/models/users/User'
import { PACK_ALLOWED_RANKS } from '@/constants/packs'
import InventoryItem from '@/models/configuration/InventoryItem'
import Achievement from '@/models/competitions/Achievement'
import Quest from '@/models/competitions/Quest'
import { axiosCatch } from '@/mixins/crud/methods/axios-catch'
import { paginationWatch } from '@/mixins/crud/watch/pagination'
import thousandSeparator from '@/mixins/thousand-separator'
import { deleteDialog } from '@/mixins/crud/watch/delete-dialog'
import user from '@/mixins/crud/computed/user'
import isRole from '@/mixins/crud/computed/isRole'
import convertDate from '@/mixins/convert-date'
import formatTime from '@/mixins/format-time'
import formatDate from '@/mixins/format-date'
import required from '@/mixins/rules/required'
import RequiredFields from '@/components/crud/RequiredFields.vue'
import SimulateSessionDialog from '@/components/SimulateSessionDialog.vue'
import Session from '@/models/main/Session'
import EditButton from '@/components/crud/edit/EditButton.vue'
import EditToolbar from '@/components/crud/edit/EditToolbar.vue'
import ValidationErrors from '@/components/crud/ValidationErrors.vue'
import EditCardActions from '@/components/crud/edit/EditCardActions.vue'
import COUNTRIES from '@/mixins/countries'
import DeleteToolbar from '@/components/crud/delete/DeleteToolbar.vue'
import DeleteCardActions from '@/components/crud/delete/DeleteCardActions.vue'
import DeleteButton from '@/components/crud/delete/DeleteButton.vue'
import { logout } from '@/mixins/logout'
import Role from '@/models/users/Role'
import convertCase from '@/mixins/convert-case'
import KpiUserApi from '@/services/kpi/KpiUserApi'
import GamesApi from '@/services/configuration/GamesApi'
import Arena from '@/models/setup/Arena'

export default Vue.extend({
  props: {
    entity: {
      type: Object,
      required: true,
    },
    userSessionInitial: {
      type: Object,
    },
    initRoles: {
      type: Array,
      default: () => [],
    },
    arenas: {
      type: Array,
      default: () => [],
    },
    viewButton: {
      type: Boolean,
      default: true,
    },
    shopButton: {
      type: Boolean,
      default: true,
    },
    awardButton: {
      type: Boolean,
      default: true,
    },
    simulateSessionButton: {
      type: Boolean,
      default: true,
    },
    sessionButton: {
      type: Boolean,
      default: true,
    },
    editButton: {
      type: Boolean,
      default: true,
    },
    deleteButton: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['user-session-action', 'shop-button-clicked', 'user-updated'],
  components: {
    DeleteButton,
    DeleteCardActions,
    DeleteToolbar,
    EditCardActions,
    SimulateSessionDialog,
    ValidationErrors,
    EditToolbar,
    EditButton,
    RequiredFields,
    PrimaryChip,
    ExperienceImage,
    BooleanComponent,
    CoinIcon,
    Status,
    CopyTooltip,
    ProgressCircular,
  },

  mixins: [
    axiosCatch,
    paginationWatch,
    thousandSeparator,
    deleteDialog,
    user,
    isRole,
    convertDate,
    formatTime,
    formatDate,
    required,
    convertCase,
  ],

  data: () => ({
    loadingView: false,
    viewDialog: false,
    resettingPassword: false,
    approvingIdentity: false,
    rejectingIdentity: false,
    userMostPurchased: [],
    loadingUserMostPurchased: false,
    userMostGames: [],
    loadingUserMostPlayedGames: false,

    loadingAward: false,
    awardDialog: false,
    awardingEvent: false,
    events: [
      {
        name: 'Win with a friend',
        type: 'on_lan_win',
      },
      {
        name: 'Instagram Follow',
        type: 'on_instagram_followed',
      },
      {
        name: 'TikTok Follow',
        type: 'on_tik_tok_followed',
      },
      {
        name: 'Significant Other Visit',
        type: 'on_playing_with_significant_other',
      },
      {
        name: 'Staff Drink Treat',
        type: 'on_buy_drink_for_staff',
      },
      {
        name: 'Birthday Party',
        type: 'on_birthday_party',
      },
      {
        name: 'FF League Participation',
        type: 'on_friendly_fire_league_participation',
      },
      {
        name: 'FF Competition Win',
        type: 'on_friendly_fire_competition_win',
      },
      {
        name: 'LEGEND',
        type: 'on_become_legend',
      },
    ],

    showSimulateDialog: false,
    loadingSimulation: false,

    loadingSessions: false,
    userSession: null,

    editDialog: false,
    validationErrors: [],
    countries: COUNTRIES,
    menu: false,
    activePicker: null,
    roles: [],
    show: false,
    saving: false,

    deleteDialog: false,
    deleting: false,

    localArenas: [],

    editedEntity: {
      id: null,
      username: '',
      password: '',
      card_id: '',
      availableCoins: 0,
      wanted_playtime_hours: 0,
      wanted_playtime_minutes: 0,
      roles: [],
      banned: false,
      ban_arena_id: null,
      ban_reason: '',
      keycloak_id: null,
      identity: {
        id: null,
        name: '',
        birthdate: null,
        address: '',
        pidn: '',
        image: '',
        status: '',
      },
      phone: {
        country_code: '',
        national_number: '',
      },
      email: {
        address: '',
      },
      wallet: {},
      settings: [],
      inventory: [],
      bonuses: {
        legend_bonus: 0,
        rank_bonus: 0,
        reward_bonus: 0,
        subscription_bonus: 0,
      },
      achievements: [],
      quests: [],
      event: null,
      selectedSimulatorOption: {},
    },
    defaultEntity: {
      id: null,
      username: '',
      password: '',
      card_id: '',
      availableCoins: 0,
      wanted_playtime_hours: 0,
      wanted_playtime_minutes: 0,
      roles: [],
      banned: false,
      ban_arena_id: null,
      ban_reason: '',
      keycloak_id: null,
      identity: {
        id: null,
        name: '',
        birthdate: null,
        address: '',
        pidn: '',
        image: '',
        status: '',
      },
      phone: {
        country_code: '',
        national_number: '',
      },
      email: {
        address: '',
      },
      wallet: {},
      settings: [],
      inventory: [],
      bonuses: {
        legend_bonus: 0,
        rank_bonus: 0,
        reward_bonus: 0,
        subscription_bonus: 0,
      },
      achievements: [],
      quests: [],
      event: null,
      selectedSimulatorOption: {},
    },
    toDeleteEntity: {
      id: null,
      username: '',
      password: '',
      card_id: '',
      roles: [],
      banned: false,
      ban_arena_id: null,
      ban_reason: '',
      keycloak_id: null,
      identity: {
        id: null,
        name: '',
        birthdate: null,
        address: '',
        pidn: '',
        image: '',
        status: '',
      },
      phone: {
        country_code: '',
        national_number: '',
      },
      email: {
        address: '',
      },
      wallet: {},
      settings: [],
      inventory: [],
      bonuses: {
        legend_bonus: 0,
        rank_bonus: 0,
        reward_bonus: 0,
        subscription_bonus: 0,
      },
      achievements: [],
      quests: [],
      event: null,
      selectedSimulatorOption: {},
    },
    localEntity: null,
  }),

  computed: {
    isTargetAdmin() {
      return this.localEntity?.roles?.includes('admin') ?? false
    },
    isStarterRank() {
      if (
        !this.editedEntity ||
        !this.editedEntity.experience ||
        !this.editedEntity.experience.rank
      ) {
        return false
      }

      const rankName = this.editedEntity.experience.rank.name.toLowerCase()
      return PACK_ALLOWED_RANKS.starter.includes(rankName)
    },
    achievementsHeaders() {
      return [
        {
          text: this.$t('generalAttributes.name'),
          align: 'left',
          value: 'name',
        },
        {
          text: this.$t('entities.achievements.attributes.progress'),
          align: 'left',
          value: 'progress',
        },
        {
          text: this.$tc('entities.achievements.attributes.points', 2),
          align: 'left',
          value: 'points',
        },
        {
          text: this.$t('miscellaneous.createdAt'),
          align: 'left',
          value: 'created_at',
        },
        {
          text: this.$t('entities.achievements.attributes.progressUpdatedAt'),
          align: 'left',
          value: 'progress_updated_at',
        },
      ]
    },
    questsHeaders() {
      return [
        {
          text: this.$t('generalAttributes.name'),
          align: 'left',
          value: 'name',
        },
        {
          text: this.$t('entities.quests.attributes.pool'),
          align: 'left',
          value: 'pool_type',
        },
        {
          text: this.$t('entities.achievements.attributes.progress'),
          align: 'left',
          value: 'progress',
        },
        {
          text: this.$t('miscellaneous.createdAt'),
          align: 'left',
          value: 'created_at',
        },
        {
          text: this.$t('entities.achievements.attributes.progressUpdatedAt'),
          align: 'left',
          value: 'progress_updated_at',
        },
      ]
    },
    inventoryHeaders() {
      return [
        {
          text: this.$t('generalAttributes.name'),
          align: 'left',
          value: 'name',
        },
        {
          text: this.$t('miscellaneous.createdAt'),
          align: 'left',
          value: 'created_at',
        },
      ]
    },
    filteredEvents() {
      const filteredEvents = this.events
      if (!this.isAdmin) {
        // Remove legend from list if not admin
        filteredEvents.splice(
          filteredEvents.findIndex((a) => a.name.toLowerCase() === 'legend'),
          1,
        )
      }
      return filteredEvents
    },
    simulatorOptions() {
      return [
        {
          name: this.$t('entities.users.estimateSessionCost'),
          context: {
            type: 'estimate-cost',
          },
        },
        {
          name: this.$t('entities.users.estimateSessionDuration'),
          context: {
            type: 'estimate-duration',
          },
        },
      ]
    },
    arenaId() {
      return this.$store.getters.arena ? `${this.$store.getters.arena.id}` : ''
    },

    banArenaName() {
      const arena = this.localArenas.find(
        (a) => a.id === this.localEntity.ban_arena_id,
      )
      return arena ? arena.name : ''
    },

    numeric() {
      return (v) => !isNaN(v) || this.$t('validation.numeric')
    },
    min() {
      return (v) => v >= 0 || this.$t('validation.min', { amount: 0 })
    },
    formTitle() {
      return this.editDialog
        ? this.$t(
            `entities.${this.entity}.${
              this.editedIndex === -1 ? 'new' : 'edit'
            }Entity`,
          )
        : ''
    },
    email() {
      return (v) =>
        !v ||
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v,
        ) ||
        this.$t('validation.email')
    },
    availableRoles() {
      if (this.isAdmin) {
        return this.roles.map((role) => role.name)
      }
      if (this.isManager) {
        return this.roles
          .filter((role) => role.name !== 'admin' && role.name !== 'manager')
          .map((role) => role.name)
      }
      return this.roles
        .filter((role) => role.is_default)
        .map((role) => role.name)
    },
    minimumPasswordOrEmpty() {
      return (v) =>
        !v ||
        (v && v.length >= 6) ||
        this.$t('validation.minimum', { count: 6 })
    },
    progress() {
      let strength = 0

      if (this.editedEntity.password) {
        strength +=
          /[A-Z]+/.test(this.editedEntity.password) &&
          this.editedEntity.password.length > 1
            ? 25
            : 0
        strength +=
          /[a-z]+/.test(this.editedEntity.password) &&
          this.editedEntity.password.length > 3
            ? 25
            : 0
        strength +=
          /[0-9]+/.test(this.editedEntity.password) &&
          this.editedEntity.password.length > 5
            ? 25
            : 0
        strength +=
          /[\W]+/.test(this.editedEntity.password) &&
          this.editedEntity.password.length > 7
            ? 25
            : 0
      }

      return strength
    },
    color() {
      return ['red', 'red', 'orange', 'yellow', 'green'][
        Math.floor(this.progress / 25)
      ]
    },
    phoneNumber() {
      return (v) =>
        !v || /^[1-9]\d*$/.test(v) || this.$t('validation.phoneNumber')
    },
    requiredIfCountryCode() {
      return (v) => {
        if (this.editedEntity.phone.country_code && !v) {
          return this.$t('validation.required')
        }
        return true
      }
    },
    requiredIfBanned() {
      return (v) => {
        if (this.editedEntity.banned && !v) {
          return this.$t('validation.required')
        }
        return true
      }
    },
  },

  created() {
    if (this.userSessionInitial) {
      this.userSession = { ...this.userSessionInitial }
    }

    this.defaultEntity = JSON.parse(JSON.stringify(this.editedEntity))
    this.localEntity = { ...this.entity }

    if (this.initRoles.length) {
      this.roles = this.initRoles
    } else if (this.editButton) {
      this.fetchRoles()
    }

    this.localArenas = this.arenas
    if (this.localArenas.length === 0 && this.localEntity.banned) {
      this.fetchArenas()
    }
  },

  watch: {
    entity: {
      handler(newEntity) {
        this.localEntity = { ...newEntity }
      },
      deep: true,
      immediate: true,
    },
    menu(val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },
    viewDialog(val) {
      if (!val) {
        this.closeViewDialog()
      } else {
        this.fetchSelectedUserMostPurchasedItems(this.editedEntity.id)
        this.fetchSelectedUserMostPlayedGames(this.editedEntity.id)
      }
    },
    awardDialog(val) {
      if (!val) {
        this.closeAwardDialog()
      }
    },
    simulateSessionDialog(val) {
      if (!val) {
        this.closeSimulateSessionDialog()
      }
    },
    userSessionInitial(val) {
      this.userSession = val
    },
    'editedEntity.phone.country_code'(newVal) {
      if (!newVal) {
        this.editedEntity.phone.national_number = ''
      }
    },
    'editedEntity.banned': async function (newVal) {
      if (!newVal) {
        this.editedEntity.ban_reason = ''
        this.editedEntity.ban_arena_id = null
      } else {
        if (this.editedEntity.ban_arena_id) {
          return
        }

        if (this.$store.getters.arena) {
          this.editedEntity.ban_arena_id = this.$store.getters.arena.id
        }
      }
    },
  },

  methods: {
    ...mapActions(['showSnackbar']),

    async fetchArenas() {
      try {
        const response = await Arena.api.get('size=100')
        this.localArenas = response.data.data
      } catch (e) {
        console.warn('Arenas API failed.')
        console.log(e)
      }
    },

    async openViewDialog() {
      this.loadingView = true

      if (!this.localEntity?.username) {
        await this.setLocalEntity()
      }

      this.editedEntity = { ...this.localEntity }

      const [wallet, experience, inventory, bonuses, achievements, quests] =
        await Promise.all([
          this.getUserWallet(this.editedEntity.id),
          this.getUserExperience(this.editedEntity.id),
          this.getUserInventory(this.editedEntity.id),
          this.getUserBonuses(this.editedEntity.id),
          this.getUserAchievements(this.editedEntity.id, '&view=true'),
          this.getUserQuests(this.editedEntity.id, '&view=true'),
        ])

      this.editedEntity.wallet = wallet
      this.editedEntity.experience = experience
      this.editedEntity.bonuses = bonuses
      this.editedEntity.achievements = achievements
      this.editedEntity.quests = quests
      this.editedEntity.inventory = inventory

      this.viewDialog = true
      this.loadingView = false
    },
    closeViewDialog() {
      this.editedEntity = JSON.parse(JSON.stringify(this.defaultEntity))
    },

    async openAwardDialog() {
      this.loadingAward = true

      if (!this.localEntity?.username) {
        await this.setLocalEntity()
      }

      this.editedEntity = { ...this.localEntity }
      this.awardDialog = true
      this.loadingAward = false
    },
    closeAwardDialog() {
      this.editedEntity = JSON.parse(JSON.stringify(this.defaultEntity))
    },

    openSimulateSessionDialog() {
      this.loadingSimulation = true
      this.showSimulateDialog = true
      // Reset loading state after dialog appears
      this.$nextTick(() => {
        this.loadingSimulation = false
      })
    },

    async emitSessionAction() {
      this.$emit('user-session-action')
    },

    async openEditDialog() {
      if (!this.localEntity?.username) {
        await this.setLocalEntity()
      }

      this.editedEntity = { ...this.localEntity }
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }

      if (this.localArenas.length === 0) {
        await this.fetchArenas()
      }

      this.editDialog = true
    },

    closeEditDialog() {
      this.editedEntity = JSON.parse(JSON.stringify(this.defaultEntity))
      this.editDialog = false
    },

    async openDeleteDialog() {
      if (!this.localEntity?.username) {
        await this.setLocalEntity()
      }
      const [wallet, experience] = await Promise.all([
        this.getUserWallet(this.localEntity.id),
        this.getUserExperience(this.localEntity.id),
      ])

      this.toDeleteEntity = { ...this.localEntity }
      this.toDeleteEntity.wallet = wallet
      this.toDeleteEntity.experience = experience

      this.deleteDialog = true
    },
    closeDeleteDialog() {
      this.deleteDialog = false
      this.toDeleteEntity = { ...this.defaultEntity }
    },

    async getUserInventory(id) {
      let data = []
      try {
        const response = await User.api.getInventoryItems(id)
        data = response.data.map(
          (InventoryItemDTO) => new InventoryItem(InventoryItemDTO),
        )
      } catch (e) {
        console.warn(`User Inventory API failed.`)
        console.log(e)
      }
      return data
    },
    async getUserWallet(id) {
      let wallet = {}
      try {
        const response = await User.api.getWallet(id)
        wallet = response.data
      } catch (e) {
        console.warn(`User Inventory API failed.`)
        console.log(e)
      }
      return wallet
    },
    async getUserExperience(id) {
      let experience = {}
      try {
        const response = await User.api.getXp(id)
        experience = response.data
      } catch (e) {
        console.warn(`User Inventory API failed.`)
        console.log(e)
      }
      return experience
    },
    async getUserBonuses(id) {
      let data = []
      try {
        const response = await User.api.getBonuses(id)
        data = response.data
      } catch (e) {
        console.warn(`User Bonuses API failed.`)
        console.log(e)
      }
      return data
    },
    async getUserAchievements(id, append = '') {
      let data = []
      try {
        const response = await User.api.getAchievements(id, append)
        data = response.data.content.map(
          (AchievementDTO) => new Achievement(AchievementDTO),
        )
      } catch (e) {
        console.warn(`User Achievements API failed.`)
        console.log(e)
      }
      return data
    },
    async getUserQuests(id, append = '') {
      let data = []
      try {
        const response = await User.api.getQuests(id, append)
        data = response.data.content.map((QuestDTO) => new Quest(QuestDTO))
      } catch (e) {
        console.warn(`User Quests API failed.`)
        console.log(e)
      }
      return data
    },
    goToCoinHistory() {
      this.$router
        .push({
          name: 'navigationDrawer.users.coinHistory',
          params: { arena: this.$route.params.arena },
          query: { user_id: this.editedEntity.id },
        })
        .catch(() => undefined)
    },
    async resetPassword(id) {
      try {
        this.resettingPassword = true
        await User.api
          .resetPassword(id)
          .then((response) => {
            this.editedEntity.reset_password = response.data.reset_password
            this.showSnackbar({
              color: 'success',
              message: this.$t(`entities.users.notifications.resetPassword`),
            })
          })
          .catch((error) => {
            this.axiosCatch(error)
          })
      } catch (error) {
        console.warn(`User Reset Password API failed.`)
        console.log(error)
      } finally {
        this.resettingPassword = false
      }
    },
    canManage() {
      if (this.isTargetAdmin) {
        return false
      }
      if (this.isAdmin) {
        return true
      }
      if (this.isManager) {
        return !this.editedEntity.roles?.some(
          (r) => ['admin', 'manager'].indexOf(r) >= 0,
        )
      }
      return !this.editedEntity.roles?.some(
        (r) => ['admin', 'employee', 'manager'].indexOf(r) >= 0,
      )
    },
    async approveIdentity(id) {
      try {
        this.approvingIdentity = true
        await User.api
          .approveIdentity(id)
          .then((response) => {
            this.editedEntity.identity.status = response.data.status
            this.showSnackbar({
              color: 'success',
              message: this.$t(`entities.users.notifications.approveIdentity`),
            })
          })
          .catch((error) => {
            if (error.response.status === 403) {
              this.showSnackbar({
                color: 'error',
                message: error.response.data.message,
              })
            }
          })
      } catch (error) {
        console.warn(`User Approve Identity API failed.`)
        console.log(error)
      } finally {
        this.approvingIdentity = false
      }
    },
    async rejectIdentity(id) {
      try {
        this.rejectingIdentity = true
        await User.api
          .rejectIdentity(id)
          .then((response) => {
            this.editedEntity.identity.status = response.data.status
            this.showSnackbar({
              color: 'success',
              message: this.$t(`entities.users.notifications.rejectIdentity`),
            })
          })
          .catch((error) => {
            this.axiosCatch(error)
          })
      } catch (error) {
        console.warn(`User Reject Identity API failed.`)
        console.log(error)
      } finally {
        this.rejectingIdentity = false
      }
    },
    async fetchSelectedUserMostPurchasedItems(userId) {
      this.loadingUserMostPurchased = true

      if (this.userMostPurchased.length > 0) {
        this.loadingUserMostPurchased = false
        return
      }

      try {
        const endDate = new Date()
        const startDate = new Date()
        startDate.setFullYear(endDate.getFullYear() - 1)
        const response = await KpiUserApi.getMostSoldToUser(
          userId,
          startDate,
          endDate,
        )

        this.userMostPurchased = response.data
      } catch (e) {
        console.warn('KPI User API failed.')
        console.log(e)
      } finally {
        this.loadingUserMostPurchased = false
      }
    },
    async fetchSelectedUserMostPlayedGames(userId) {
      this.loadingUserMostPlayedGames = true

      if (this.userMostGames.length > 0) {
        7
        this.loadingUserMostPlayedGames = false
        return
      }

      try {
        const endDate = new Date()
        const startDate = new Date()
        startDate.setFullYear(endDate.getFullYear() - 1)
        const response = await KpiUserApi.getMostPlayedByUser(
          userId,
          startDate,
          endDate,
        )
        this.userMostGames = response.data

        if (this.userMostGames.length > 0) {
          const searchParams =
            'game_ids=' +
            this.userMostGames.map((game) => game.game_id).join('&game_ids=')
          const gamesResponse = await GamesApi.search(searchParams)
          const games = gamesResponse.data.data
          this.userMostGames.forEach((game) => {
            const gameData = games.find((g) => g.id === game.game_id)
            if (gameData) {
              game.name = gameData.name
            }
          })
        }
      } catch (e) {
        console.warn('KPI User API failed.')
        console.log(e)
      } finally {
        this.loadingUserMostPlayedGames = false
      }
    },

    async createPurchase() {
      this.$emit('shop-button-clicked')
      if (!this.localEntity?.username) {
        await this.setLocalEntity()
      }

      const routeParams = { arena: this.arenaId }

      const selectedCustomer = {
        id: this.localEntity.id,
        username: this.localEntity.username || '',
        name: this.localEntity.identity?.name || this.localEntity.name || '',
        email: this.localEntity.email?.address || this.localEntity.email || '',
        coins: this.localEntity.wallet?.balance ?? 0,
        experience: this.localEntity.experience || { rank: { name: '' } },
        topProducts: [],
        topGames: [],
        returningUser: this.localEntity.returningUser || false,
        offerStarterPack: this.localEntity.offerStarterPack || false,
      }
      this.$store.dispatch('cart/setSelectedCustomer', selectedCustomer)

      if (this.$route.name !== 'navigationDrawer.shop.purchase') {
        await this.$router.push({
          name: 'navigationDrawer.shop.purchase',
          params: routeParams,
        })
      } else {
        this.$router
          .replace({ path: '/temp' }) // Navigate to a temporary route
          .then(() => {
            this.$router.replace({
              name: 'navigationDrawer.shop.purchase',
              params: routeParams,
            })
          })
      }
    },

    awardEvent() {
      if (!this.$refs.awardForm.validate()) {
        return
      }

      this.awardingEvent = true

      const data = {
        type: this.editedEntity.event.type,
        data: {
          user_id: this.editedEntity.id,
        },
      }

      User.api
        .awardEvent(data)
        .then(() => {
          this.awardDialog = false
          this.showSnackbar({
            color: 'success',
            message: this.$t('entities.users.notifications.progress'),
          })
        })
        .catch((error) => {
          this.showSnackbar({
            color: 'error',
            message: this.$t('error', { message: error.response.status }),
          })
        })
        .finally(() => {
          this.awardingEvent = false
        })
    },

    async estimateSessionDuration() {
      if (!this.$refs.estimateDurationForm.validate()) {
        return
      }

      this.simulatingSession = true
      const data = {
        user_id: this.editedEntity.id,
        coins: parseInt(this.editedEntity.availableCoins),
      }
      try {
        const simulateSessionResponse = await Session.api
          .simulateSession(this.$store.getters.arena.id, data)
          .catch((error) => {
            this.simulatingSession = false
            this.simulationResult = null
            if (error.response.status >= 300) {
              this.showSnackbar({
                color: 'error',
                message: error.response.data,
              })
            }
          })
        if (simulateSessionResponse.status < 300) {
          this.simulationResult = simulateSessionResponse.data
        }
      } catch (error) {
        console.warn(`Simulate Arena Session API Error`)
        console.log(error)
        this.simulationResult = null
      }
      this.simulatingSession = false
    },
    async estimateSessionCost() {
      if (!this.$store.getters.arena.id) {
        return
      }

      if (!this.$refs.estimateCostForm.validate()) {
        return
      }

      this.simulatingSession = true
      const data = {
        user_id: this.editedEntity.id,
        duration_minutes:
          Number(this.editedEntity.wanted_playtime_hours) * 60 +
          Number(this.editedEntity.wanted_playtime_minutes),
      }
      try {
        const simulateSessionResponse = await Session.api
          .simulateSession(this.$store.getters.arena.id, data)
          .catch((error) => {
            this.simulatingSession = false
            this.simulationResult = null
            if (error.response.status >= 300) {
              this.showSnackbar({
                color: 'error',
                message: error.response.data,
              })
            }
          })
        if (simulateSessionResponse.status < 300) {
          this.simulationResult = simulateSessionResponse.data
        }
      } catch (error) {
        console.warn(`Simulate Arena Session API Error`)
        console.log(error)
        this.simulationResult = null
      }
      this.simulatingSession = false
    },
    getHoursFromMinutes(minutes) {
      return Math.floor(Number(minutes) / 60)
    },
    getRemainingMinutes(minutes) {
      return Math.round(Number(minutes) % 60)
    },
    getHoursFromSeconds(seconds) {
      return this.getHoursFromMinutes(Math.floor(Number(seconds) / 60))
    },
    getRemainingMinutesFromSeconds(seconds) {
      return this.getRemainingMinutes(Number(seconds) / 60)
    },

    async startPSSession() {
      try {
        this.loadingSessions = true

        if (!this.localEntity?.username) {
          await this.setLocalEntity()
        }

        const data = {
          arena_id: this.$store.getters.arena.id,
          device_id: 'ps',
          username: this.localEntity.username,
          user_id: this.localEntity.id,
        }
        await Session.api
          .create(this.$store.getters.arena.id, data)
          .then(() => {
            this.emitSessionAction()
          })
          .catch((error) => {
            this.loadingSessions = false
            // Server error
            if (error.response.status === 500) {
              this.showSnackbar({
                color: 'error',
                message: error.response.data,
              })
            } else {
              this.showSnackbar({
                color: 'error',
                message: this.$t(
                  `entities.sessions.errorCodes.${error.response.data.code}`,
                ),
              })
            }
          })
      } catch (error) {
        console.warn(`Start Arena PlayStation Session API failed.`)
        console.log(error)
      } finally {
        this.loadingSessions = false
      }
    },
    async startSimulatorSession() {
      try {
        this.loadingSessions = true

        if (!this.localEntity?.username) {
          await this.setLocalEntity()
        }

        const data = {
          arena_id: this.$store.getters.arena.id,
          device_id: 'sim',
          username: this.localEntity.username,
          user_id: this.localEntity.id,
        }
        await Session.api
          .create(this.$store.getters.arena.id, data)
          .then(() => {
            this.emitSessionAction()
          })
          .catch((error) => {
            this.loadingSessions = false
            // Server error
            if (error.response.status === 500) {
              this.showSnackbar({
                color: 'error',
                message: error.response.data,
              })
            } else {
              this.showSnackbar({
                color: 'error',
                message: this.$t(
                  `entities.sessions.errorCodes.${error.response.data.code}`,
                ),
              })
            }
          })
      } catch (error) {
        console.warn(`Start Arena Simulator Session API failed.`)
        console.log(error)
      } finally {
        this.loadingSessions = false
      }
    },
    async stopSession() {
      if (!this.userSession) {
        return
      }

      try {
        this.loadingSessions = true
        const session = this.userSession
        const data = {
          reason: 'closed_by_employee',
        }
        await Session.api
          .destroy(this.$store.getters.arena.id, session.id, data)
          .then(() => {
            this.emitSessionAction()
          })
          .catch((error) => {
            this.loadingSessions = false
            // Server error
            if (error.response.status === 500) {
              this.showSnackbar({
                color: 'error',
                message: error.response.data,
              })
            }
          })
      } catch (error) {
        console.warn(`Delete Arena Session API failed.`)
        console.log(error)
      } finally {
        this.loadingSessions = false
      }
    },

    saveDate(date) {
      this.$refs.menu.save(date)
    },
    async fetchRoles() {
      try {
        const response = await Role.api.get('size=100')
        this.roles = response.data.content
      } catch (e) {
        console.warn('Roles API failed.')
        console.log(e)
      }
    },

    async save() {
      try {
        this.saving = true

        if (!this.$refs.form.validate()) {
          return
        }

        const data = {
          roles: this.editedEntity.roles,
          banned: this.editedEntity.banned,
        }

        if (this.editedEntity.banned) {
          data.ban_reason = this.editedEntity.ban_reason
          data.ban_arena_id = this.editedEntity.ban_arena_id
        }

        if (this.$store.getters.arena) {
          data.registered_in_arena = this.$store.getters.arena.id
        }

        if (this.editedEntity.card_id) {
          data.card_id = this.editedEntity.card_id
        }

        // Password not required on update
        if (this.editedEntity.password && this.editedEntity.password.length) {
          data.password = this.editedEntity.password
        }

        // Only on create
        if (this.editedIndex === -1) {
          data.username = this.editedEntity.username
        }

        if (
          this.editedEntity.identity.name ||
          this.editedEntity.identity.pidn ||
          this.editedEntity.identity.address ||
          this.editedEntity.identity.birthdate
        ) {
          data.identity = {
            country_code: this.$store.state.country.toUpperCase(),
          }
        }

        if (this.editedEntity.identity.name) {
          data.identity.name = this.editedEntity.identity.name
        }

        if (this.editedEntity.identity.pidn) {
          data.identity.pidn = this.editedEntity.identity.pidn
        }

        if (this.editedEntity.identity.address) {
          data.identity.address = this.editedEntity.identity.address
        }

        if (this.editedEntity.identity.birthdate) {
          data.identity.birthdate = this.editedEntity.identity.birthdate
        }

        // TODO => Image
        // if (this.editedEntity.identity.image) {
        //     data.identity.image = this.editedEntity.identity.image;
        // }

        if (
          this.editedEntity.phone.country_code &&
          this.editedEntity.phone.national_number
        ) {
          data.phone = {
            country_code: this.editedEntity.phone.country_code,
            national_number: this.editedEntity.phone.national_number,
          }
        }

        if (this.editedEntity.email.address) {
          data.email = this.editedEntity.email.address
        }

        await User.api
          .update(this.editedEntity.id, data)
          .then((response) => {
            if (this.user.id === this.editedEntity.id) {
              const user = {
                id: response.data.id,
                credential: response.data.username,
                initials: response.data.username.substring(0, 2),
                name: response.data.identity
                  ? response.data.identity.name
                  : null,
                email: response.data.email ? response.data.email.address : null,
                username: response.data.username,
                pidn: response.data.identity
                  ? response.data.identity.pidn
                  : null,
                roles: response.data.roles,
                avatar: response.data.avatar,
              }
              localStorage.setItem('user', JSON.stringify(user))
            }
            this.$emit('user-updated')
            this.showSnackbar({
              color: 'success',
              message: this.$t('entities.users.notifications.update'),
            })
            this.closeEditDialog()
          })
          .catch((error) => {
            this.axiosCatch(error)
          })
      } catch (error) {
        console.warn(`User Save API failed.`)
        console.log(error)
      } finally {
        this.saving = false
      }
    },

    async deleteEntity() {
      try {
        this.deleting = true
        await User.api
          .delete(this.toDeleteEntity.id)
          .then(() => {
            if (this.user.id === this.toDeleteEntity.id) {
              logout.methods.logout()
            }
            this.closeDeleteDialog()
            this.validationErrors = []
            this.$emit('user-deleted')
            this.showSnackbar({
              color: 'success',
              message: this.$t('entities.users.notifications.deletion'),
            })
          })
          .catch((error) => {
            this.axiosCatch(error)
          })
      } catch (error) {
        console.warn(`Delete User API failed.`)
        console.log(error)
      } finally {
        this.deleting = false
      }
    },

    async setLocalEntity() {
      const response = await User.api.find(this.entity.id)
      this.localEntity = { ...response.data }

      if (!this.localEntity.identity) {
        this.localEntity.identity = {
          name: '',
          birthdate: null,
          address: '',
          pidn: '',
          image: '',
        }
      }
      if (!this.localEntity.phone) {
        this.localEntity.phone = {
          id: null,
          country_code: '',
          national_number: null,
        }
      }
      if (!this.localEntity.email) {
        this.localEntity.email = {
          id: null,
          address: '',
          status: 'UNVERIFIED',
        }
      }
    },
  },
})
</script>

<style>
.position-relative {
  position: relative;
}

.required-fields {
  position: absolute;
  right: 13px;
  top: 15px;
  color: red;
}
</style>
